import { ProdcutRelationshipGroupTypeEnum } from '../../enums/ProductEnums';
import { ProductRelationShipDTO } from './ProductRelationshipDTO';

export class ProductRelationshipGroupDTO {
  id: number | undefined;
  productRelationships: ProductRelationShipDTO[];
  position: number[];
  type: ProdcutRelationshipGroupTypeEnum;

  constructor(
    id: number | undefined,
    productRelationships: ProductRelationShipDTO[],
    position: number[],
    type: ProdcutRelationshipGroupTypeEnum,
  ) {
    this.id = id;
    this.productRelationships = productRelationships;
    this.position = position;
    this.type = type;
  }
}
